import styled from "styled-components";
import Paper from "@material-ui/core/Paper";
import { NavLink } from "react-router-dom";

export const StyledContainer = styled(Paper)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    padding: 20px;
    & form {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
`;

export const StyledLink = styled(NavLink)`
    ${({ theme }) => `
    text-decoration: none;
    color: ${theme.palette.primary.dark};
    &.active {
        color: ${theme.palette.grey["700"]};
    }
  `}
`;
